import styled from 'styled-components';

export default styled.div`
	.bottom-line {
		content: '';
		margin: 0 7rem 0 5rem;
		width: auto;
		border-bottom: 1px solid ${(props) => props.theme.color[`grey250`]};

		&:last-of-type {
			border: 0px;
		}
	}
`;
